// STORYBLOK

import { NavigationLinkStoryblok, SubMenuStoryblok } from './storyblok/storyblok-types';

export type StoryblokLink = {
    id: number;
    slug: string;
    name: string;
    is_folder: boolean;
    parent_id: number;
    published: boolean;
    path: string;
    position: number;
    uuid: string;
    is_startpage: boolean;
    real_path: string;
};

export type AlternateStoryblokStory = {
    id: number;
    name: string;
    slug: string;
    published: boolean;
    full_slug: string;
    is_folder: boolean;
    parent_id: number;
};
export type ContentMenuType = (SubMenuStoryblok | NavigationLinkStoryblok)[];
// export type OpenMenuType = [{ key: string }];
export enum ScrollDirection {
    up = 'up',
    down = 'down',
}
